import styled, { css } from "styled-components";

const TabsWrapper = styled.div`
    display: flex;
    
`;

const Tab = styled.button`
    margin-right: 2rem;
    color: ${props => props.theme.lightGray2};
    position: relative;
    font-family: ${props => props.theme.fontBold};
    cursor: pointer;
    ${props => {
        return (
            props.active &&
            css`
                color: ${props.theme.black};
                border-bottom: ${props.theme.greenBorderThick};
            `
        );
    }}
    h2 {
        font-size: 1.2rem;
        padding-bottom: 1rem;
        margin-bottom: 0;
    }
    .notificationDot {
        width: 0.6rem;
        height: 0.6rem;
        position: absolute;
        right: -1rem;
        background-color: ${props => props.theme.red};
        border-radius: 50%;
        display: inline-block;
        margin-right: 0.5rem;
    }
    @media only screen and (min-width: ${props => props.theme.smallTablet}) {
        margin-right: 4rem;

        h2 {
            font-size: 1.9rem;
            padding-bottom: 2.2rem;
            line-height: normal;
        }
    }
`;

export { TabsWrapper, Tab };
